import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/youtube.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/documents/document-done.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/buildings-2.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/stage.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ae.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/es.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/fr.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ge.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/gr.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ua.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/currency/eur.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/currency/usd-symbol.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/currency/usd.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/buttons/home.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/controls/location-pin.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/feedback/globe.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/feedback/handshake.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/feedback/info.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/feedback/shield-check.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/feedback/spinner.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/feedback/user-circle.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/feedback/users.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/forms/award.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/forms/credit-card.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/forms/eye.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/navigation/arrow-dynamic.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/img/greece-about-background-2.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/img/greece-about-background.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Common/Loader/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/pages/AboutPage/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "/app/src/components/widgets/ContactForm/ContactForm.tsx");
